import React from 'react';
import Translate from 'react-translate-component';
import { InvoiceService } from 'frilans-finans';
import RegisteredOrdersTable from '../../../components/registered-orders/registered-orders-table';
import DashboardButton from '../../../components/dashboard-buttons/dashboard-button';
import ShowMoreButton from './show-more-button';
import { proxyCounterpart } from '../../../scripts/proxyCounterpart';

export class RegisterAssignment extends React.Component {
  static contextTypes = {
    user: React.PropTypes.object
  };
  constructor () {
    super();

    this.state = {
      fetching: true,
      fetchError: false,
      invoices: [],
      pendingRequest: null,
      meta: {
        count: 0,
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0
      }
    };

    this.fetchInvoices = this.fetchInvoices.bind(this);
    this.renderShowMoreBtn = this.renderShowMoreBtn.bind(this);
    this.removeInvoiceFromState = this.removeInvoiceFromState.bind(this);
  }

  componentDidMount () {
    this.fetchInvoices();
  }

  fetchInvoices () {
    this.setState({
      fetching: true
    });

    const page = +this.state.meta.currentPage + 1;
    const userId = +this.context.user.id;
    let pendingRequest = InvoiceService.get(userId, null, page, 1, null, 25);

    pendingRequest.promise
      .then(this.handleResponse.bind(this))
      .catch(error => {
        if (error.response !== undefined) {
          this.setState({
            fetchError: true
          });
        }
      });

    this.setState({
      pendingRequest: pendingRequest
    });
  }

  handleResponse (response) {
    this.setState({
      fetching: false,
      fetchError: false,
      invoices: this.state.invoices.concat(response.collection),
      meta: response.meta
    });
  }

  noInvoicesRow () {
    return (
      <div className='assignments-table-no-more-info'>
        {proxyCounterpart('PREREGISTERED_INVOICES_TABLE_NO_INVOICES')}
      </div>
    );
  }

  noMoreInfoRow () {
    return (
      <div className='assignments-table-no-more-info'>
        {proxyCounterpart('PREREGISTERED_INVOICES_TABLE_ALL_INVOICES_ARE_LOADED')}
      </div>
    );
  }

  renderShowMoreBtn () {
    if (this.state.meta.currentPage === this.state.meta.totalPages) {
      return this.noMoreInfoRow();
    }

    if (!this.state.meta || this.state.invoices.length <= 0) {
      return this.noInvoicesRow();
    }

    if (this.state.fetching ||
      !this.state.meta.currentPage ||
      this.state.meta.currentPage >= this.state.meta.totalPages
      ) {
      return null;
    }

    return (
      <ShowMoreButton
        text={proxyCounterpart('PREREGISTERED_INVOICES_TABLE_SHOW_MORE_INVOICES')}
        loading={this.state.fetching || false}
        callback={this.fetchInvoices}
      />
    );
  }

  removeInvoiceFromState (invoiceId) {
    this.setState({
      invoices: this.state.invoices.filter((invoice) => +invoice.id !== invoiceId)
    });
  }

  render () {
    return (
      <div className='register-assignment-container'>
        <div className='register-assignment-text-container'>
          <h2>
            <Translate className='register-assignment-title' content='REGISTERED_ASSIGNMENTS_TITLE' />
          </h2>
          <p>
            <Translate className='register-assignment-text' content='REGISTERED_ASSIGNMENTS_TEXT' />
          </p>
        </div>
        <DashboardButton
          icon={require('images/icons/dashboard-register.svg')}
          title='BUTTON_REGISTER_ASSIGNMENT'
          buttonStyle='secondary'
          link='/register-assignment'
        />
        <RegisteredOrdersTable
          invoices={this.state.invoices}
          removeInvoiceFromState={this.removeInvoiceFromState}
          user={this.context.user}
        />
        {this.renderShowMoreBtn()}
      </div>
    );
  }
}

export default RegisterAssignment;



/** WEBPACK FOOTER **
 ** ./src/views/economy-view/register-assignment/register-assignment.js
 **/